export const FETCHING_PROJECT_SUBSCRIPTIONS =
  'timely/projectSubscriptions/FETCHING_PROJECT_SUBSCRIPTIONS';
export const FETCHED_PROJECT_SUBSCRIPTIONS =
  'timely/projectSubscriptions/FETCHED_PROJECT_SUBSCRIPTIONS';
export const FETCHED_PROJECT_SUBSCRIPTIONS_ERROR =
  'timely/projectSubscriptions/FETCHED_PROJECT_SUBSCRIPTIONS_ERROR';
export const SUBSCRIBE = 'timely/projectSubscriptions/SUBSCRIBE';
export const SUBSCRIBE_ERROR = 'timely/projectSubscriptions/SUBSCRIBE_ERROR';
export const UNSUBSCRIBE = 'timely/projectSubscriptions/UNSUBSCRIBE';
export const UNSUBSCRIBE_ERROR = 'timely/projectSubscriptions/UNSUBSCRIBE_ERROR';
